import React from "react";
import {
  useDispatch,
  useSelector
} from "react-redux";
import { useTranslation } from "react-i18next";
// Core & Lab
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
// Actions
import { hideTimerExpired } from "./redux/reducer";
// Types
import { AppState } from "../../reducers";
import { useNavigate } from "react-router-dom";

const FlightTimerExpired = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const sub_domain = useSelector((state: AppState) => state.event.sub_domain);
  const show_timer_expired = useSelector((state: AppState) => state.flight.show_timer_expired);
  const onClose = () => {
    dispatch(hideTimerExpired());
    navigate(`/${sub_domain}`);
    // setTimeout(() => {
    // }, 1000);
  };
  return (
    <Dialog open={ show_timer_expired/* && window.location.pathname !== `/${sub_domain}`*/ }>
      <DialogTitle>
        <Typography style={{color: '#319FE3'}}>
          { t('flight-timer-expired-title') }
        </Typography>
      </DialogTitle>
      <DialogContent dividers>
        <Typography>
          { t('flight-timer-expired') }
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant={ 'outlined' } onClick={ onClose } style={{borderColor: '#319FE3', color: '#319FE3'}}>{ t('flight-timer-expired-understood') }</Button>
      </DialogActions>
    </Dialog>
  );
};

export default FlightTimerExpired;